__turbopack_context__.v({
  "badge": "badge-module-scss-module__M4r_XW__badge",
});
